import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import {
  API,
  fetcher,
  Pagination,
  PaginationResponse,
} from "@/shared/core-configs";
import { ActivityLabel } from "../types/ActivityLabel";

export const GET_ACTIVITY_LABELS_FETCH_KEY = "GET_ACTIVITY_LABELS";

type GetActivityLabelsParams = {
  zoneIds?: string[] | string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
} & Partial<Pagination>;

export const getActivityLabels = async (
  zoneIds?: string[] | string,
  page?: number,
  pageSize?: number,
  showDisabled = false,
  searchTerm?: string,
  sort?: string,
  order?: string,
): Promise<PaginationResponse<ActivityLabel>> => {
  const params = qr.stringify({
    zoneIds,
    pageSize,
    page,
    showDisabled,
    searchTerm,
    sort,
    order,
  });
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/zone-activity-label?${params}`,
  );
  return response.data;
};

export const useGetActivityLabels = ({
  zoneIds,
  page,
  pageSize,
  showDisabled,
  searchTerm,
  sort,
  order,
}: GetActivityLabelsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<ActivityLabel>,
    Error
  >({
    queryKey: [
      GET_ACTIVITY_LABELS_FETCH_KEY,
      zoneIds,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      sort,
      order,
    ],
    queryFn: () =>
      getActivityLabels(
        zoneIds,
        page,
        pageSize,
        showDisabled,
        searchTerm,
        sort,
        order,
      ),
    placeholderData: (prev) => prev,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
